<template>
  <div class="tuijian">
    <div class="w1">
      <div class="l-banner"></div>
    </div>
    <div class="add_bg">
      <div class="w1 need_shadow">
        <div class="w">
          <div class="view">
            <ul class="clearfix">
              <li v-for="(item, index) in newsLi" :key="index" :class="{ 'v-active': index === newsIndex }"
                @click="nhFun(index)">{{ item }}</li>
            </ul>
          </div>
          <div class="l-content">
            <div class="content-left">
              <div class="analyze-outer" v-for="(item, index) in result" :key="index">
                <div class="table">
                  <a class="head-img" :href="tolink(item.analyst_id, item.recommend_id)" target="_blank"
                    @mouseenter="analyze_detail_show(index, item)" @mouseleave="analyze_detail_hide(index)">
                    <img :src="item.analyst_face" width="105px" height="105px" />
                    <div :class="item.type == 2 ? 'f-bg b-fg' : 'f-bg'">
                      <span>{{ item.type == 1 ? '足球' : '篮球' }}分析师</span>
                    </div>
                    <div class="name">{{ item.analyst_name }}</div>
                    <div class="analyze-detail">
                      <table cellspacing="5">
                        <tr>
                          <td rowspan="2" class="logo">
                            <img :src="item.analyst_face" width="65px" height="65px" />
                          </td>
                          <td class="name">{{ item.analyst_name }}</td>
                        </tr>
                      </table>
                      <div class="detail-bm">
                        <div class="luck-bbg" title="点赞数">
                          <img src="//static.vivl1.com/static/image/3.luckyStadium/praise.png" />
                          <span>{{ item.analyst_num }}</span>
                        </div>
                        <div class="luck-gbg" title="胜率">
                          <img src="//static.vivl1.com/static/image/3.luckyStadium/victory.png" />
                          <span>{{ item.red }}%</span>
                        </div>
                      </div>
                    </div>
                  </a>
                  <div class="table-right" v-if="item.analyze_num && !isShowContent(item.type, item.state)">
                    <img v-if="item.is_hit == 1" class="hit" src="//static.vivl1.com/static/image/hit.png" />
                    <img v-else-if="item.is_hit == 2" class="hit" src="//static.vivl1.com/static/image/nohit.png" />

                    <a class="lock" href="/app">
                      <div>
                        <img src="//static.vivl1.com/static/image/lock.png" width="30px" />
                      </div>
                      <div class="hint">
                        <span>看推文分析请点击下载</span>
                        <span style="color:red;">APP</span>
                      </div>
                    </a>
                  </div>
                  <div class="table-right" v-else>
                    <img v-if="item.is_hit == 1" class="hit" src="//static.vivl1.com/static/image/hit.png" />
                    <img v-else-if="item.is_hit == 2" class="hit" src="//static.vivl1.com/static/image/nohit.png" />
                    <a class="table-right-top" :href="tolive(item, item.type)" target="_blank">
                      <div>
                        <div class="right-tt">时间</div>
                        <div class="right-tb">{{ item.matches_time }}</div>
                      </div>
                      <div>
                        <div class="right-tt">状态</div>
                        <div class="right-tb" style="color: #3494FF;">
                          {{ item.type == 2 ? stateBkName[item.state] : stateName[item.state] }}</div>
                      </div>
                      <div>
                        <div class="right-tt">主场球队</div>
                        <div class="right-tb" v-html="item.home_name_zh"></div>
                      </div>
                      <div>
                        <div class="right-tt">VS</div>
                        <div class="right-tb">VS</div>
                      </div>
                      <div>
                        <div class="right-tt">客场球队</div>
                        <div class="right-tb" v-html="item.away_name_zh"></div>
                      </div>
                      <div>
                        <div class="right-tt">推荐</div>
                        <div class="right-tb" style="color: #D24242;" v-html="item.seleltname"></div>
                      </div>
                    </a>
                    <a class="content-outer" :href="tolink(item.analyst_id, item.recommend_id)" target="_blank">
                      <div class="reason">推荐理由</div>
                      <div class="content">
                        {{ contentfn(item.content) }}
                        <span v-if="item.content.length >= 90" style="color: #1976F7;">全文</span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="end_bottom">已到底部</div>
              <div class="moreAnalyst" style="display: none;" @click="moreAnalystFun(page, type)" :page="page">
                <a>更多分析师推荐&emsp;>></a>
              </div>
            </div>
            <div class="right-outer">
              <div class="content-right">
                <div class="head-title">
                  <div>推荐榜</div>
                </div>
                <div class="recommend-outer">
                  <div :class="index % 2 == 0 ? 'recommend recommend-even' : 'recommend'" v-for="(item, index) in member"
                    :key="index" @click="analystFn(item.member_id)">
                    <table cellspacing cellpadding>
                      <tr>
                        <td rowspan="2">
                          <img class="logo" :src="item.face" width="55px" height="55px" />
                        </td>
                        <td>
                          <span class="title">{{ item.title }}</span>
                        </td>
                      </tr>
                      <tr>
                        <td style="height: 25px;">
                          <div class="recommend-data">
                            <img src="//static.vivl1.com/static/image/3.luckyStadium/win.png" title="胜率" />
                            <span title="胜率">{{ item.probability }}%</span>
                            <img src="//static.vivl1.com/static/image/3.luckyStadium/analyze.png" title="分析数"
                              style="margin-left: 25px;" />
                            <span title="分析数">{{ item.total }}</span>
                          </div>
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      newsLi: ["最新推荐", "历史推荐"],
      newsIndex: 0,
      page: 1, //查看更多默认第二页,每点击一次+1
      type: 0, //查看更多默认0是最新推荐,1是历史推荐
      memberId: 0,
      num: 10,
      dateStr: String,
      result: [],
      member: [],
      stateName: {
        "0": "未开赛",
        "1": "上半场",
        "2": "中场",
        "3": "下半场",
        "4": "加时",
        "5": "点球",
        "-1": "完场",
        "-10": "取消",
        "-11": "待定",
        "-12": "腰斩",
        "-13": "中断",
        "-14": "推迟",
      },
      stateBkName: {
        "0": "未开赛",
        "1": "第一节",
        "2": "第二节",
        "3": "第三节",
        "4": "第四节",
        "5": "加时",
        "6": "加时",
        "7": "加时",
        "-1": "完场",
        "-2": "待定",
        "-3": "中断",
        "-4": "取消",
        "-5": "推迟",
        "50": "中场",
      },
      headCon: headCon(),
    };
  },
  created: function () {
    this.dataFun();
  },
  beforeMount() {
    var wx_login_t = this.$route.query.wx_login_t;
    if (wx_login_t) {
      var href = location.href;
      if (location.href.indexOf("&") == -1) {
        href = href.replace("?wx_login_t=" + wx_login_t, "");
      } else {
        href = href.replace("&wx_login_t=" + wx_login_t, "");
        href = href.replace("wx_login_t=" + wx_login_t + "&", "");
      }
      history.pushState("", "", href);
    }
  },
  mounted: function () {
    $(".haed_tuijian").addClass("nuxt-link-exact-active");
    this.asyncDataFn(this.num);
    this.scroll();
    $("footer").show();
  },
  methods: {
    request(url, fn) {
      url = COMMOND.NEW_BASE_URL + url;
      axios.get(url).then((res) => {
        if (fn) {
          fn(res.data);
        }
      });
    },
    isShowContent(type, state, item) {
      if (type == 1) {
        if (state >= 0 && state <= 5) {
          return false;
        } else {
          return true;
        }
      } else {
        if (state >= 0 && state <= 7 && state != 50) {
          return false;
        } else {
          return true;
        }
      }
    },
    asyncDataFn(num) {
      var date = new Date();
      var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
      var month =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1); //获取当前月份(0-11,0代表1月)
      var day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate(); //获取当前日(1-31)
      var riqi = "" + year + month + day;
      $(".end_bottom").text("加载中...");
      $(".end_bottom").css("display", "block");
      this.request("luckball?page=1&num=10&day=" + riqi, this.getResult);
      this.request("recommend_day", this.getMember);
    },
    getResult(data) {
      if (!data.data) {
        data.data = [];
      }
      this.result = this.result.concat(data.data);
      if (data.data.length < this.num) {
        $(".end_bottom").css("display", "block");
        $(".moreAnalyst").css("display", "none");
      } else {
        $(".end_bottom").css("display", "none");
        $(".moreAnalyst").css("display", "block");
      }
      if (this.result.length == 0) {
        if (this.newsIndex) {
          $(".end_bottom").text("没有历史数据");
        } else {
          $(".end_bottom").text("没有最新数据");
        }
      } else {
        $(".end_bottom").text("已到底部");
      }
    },
    getMember(data) {
      this.member = data.data;
    },
    analyze_detail_show(index, item) {
      var div = $($(".analyze-outer .analyze-detail")[index]);
      div.css("display", "block");
    },
    analyze_detail_hide(index) {
      var div = $($(".analyze-outer .analyze-detail")[index]);
      div.css("display", "none");
      //		div.empty()
    },
    tolink(id, recommend_id) {
      return (
        "/tuijian/football-analyst?member_id=" +
        id +
        "&recommend_id=" +
        recommend_id +
        "&newsIndex=" +
        this.newsIndex
      );
    },
    tolive(item, type) {
      var zhibo = 0;
      if (item.is_tv) {
        zhibo = 1;
      }
      if (type == 1) {
        return (
          window.location.protocol +
          "//" +
          window.location.host +
          "/zuqiu/live?id=" +
          item.tournament_id +
          "&zhibo=" +
          zhibo
        );
      } else {
        return (
          window.location.protocol +
          "//" +
          window.location.host +
          "/lanqiu/live?id=" +
          item.tournament_id +
          "&zhibo=" +
          zhibo
        );
      }
    },
    scroll() {
      $(window.document).scroll(function () {
        var scrolltop = $(document).scrollTop();
        if (scrolltop >= 460) {
          var left =
            $(".content-left").offset().left + $(".content-left").width();
          $(".right-outer")
            .css("position", "fixed")
            .css("left", left + "px")
            .css("top", "24px");
        } else {
          $(".right-outer").css("position", "").css("top", "").css("left", "");
        }
      });
    },
    contentfn(con) {
      con = con.replace(" ", "");
      if (con.length >= 90) {
        return con.substring(0, 90) + "...";
      } else {
        return con;
      }
    },
    analystFn(id) {
      this.memberId = id;
      this.nhFun(this.newsIndex, this.memberId);
    },
    axiosFun(page, num, day) {
      //分析师列表数据
      var url = "";
      if (this.memberId) {
        url = "luckball?member_id=" + this.memberId + "&";
      } else {
        url = "luckball?";
      }
      if (day) {
        url += "page=" + page + "&num=" + num + "&day=" + day;
      } else {
        url += "page=" + page + "&num=" + num;
      }
      this.request(url, this.getResult);
    },
    nhFun(index, memberId) {
      //最新/历史推荐
      var that = this;
      this.newsIndex = index;
      this.result = [];
      if (!memberId) {
        this.memberId = 0;
      }
      $(".end_bottom").text("加载中...");
      $(".end_bottom").css("display", "block");
      $(".moreAnalyst").css("display", "none");
      if (index == 0) {
        //今日推荐0 历史推荐1
        that.page = 1; //切换最新和历史推荐还原页数;
        that.type = 0; //0是今日 1是历史
        $(".introduce").remove();
        that.axiosFun(that.page, 10, that.dateStr);
      } else {
        that.page = 1;
        that.type = 1;
        $(".introduce").remove();
        that.axiosFun(that.page, 10);
      }
    },
    moreAnalystFun(page, type) {
      //更多分析师按钮
      var that = this;
      that.page = page + 1;
      if (type == 0) {
        //今日推荐
        that.axiosFun(that.page, 10, that.dateStr);
      } else if (type == 1) {
        //历史推荐
        that.axiosFun(that.page, 10);
      }
    },
    dataFun() {
      //日期
      var date = new Date();
      var year = date.getFullYear(); //获取完整的年份(4位,1970-????)
      var month =
        date.getMonth() + 1 >= 10
          ? date.getMonth() + 1
          : "0" + (date.getMonth() + 1); //获取当前月份(0-11,0代表1月)
      var day = date.getDate() >= 10 ? date.getDate() : "0" + date.getDate(); //获取当前日(1-31)
      this.dateStr = "" + year + month + day;
    },
    addResult(result) {
      this.result.unshift(result);
    },
  },
  metaInfo() {
    return {
      title: "每日精推",
      meta: [
        {
          hid: "description",
          name: "description",
          content: "",
        },
        {
          hid: "keywords",
          name: "keywords",
          content: "",
        },
      ],
    };
  },
};
</script>

<style>
@import "../../assets/css/lucky-stadium.css";
</style>